module.exports = __webpack_public_path__ + "img/chr_ts_16_penlight.ba90d32b.png";